import React, { useEffect, useState, useRef, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useHistory } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListPayments(props) {
  const apiToken = useContext(TokenContext);
  let query = useQuery();
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  let history = useHistory();

  const refreshPayments = () => {
    const id = query.get("id");
    if (!apiToken || !id) return Promise.resolve();

    return Repo.getListPaymentOperator(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          setPaymentsTemp(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    refreshPayments();
  }, []);

  return (<>
  
  





  {paymentsTemp && paymentsTemp.length > 0 ? (
 
      <ListPaymemtsUsers
        payments={payments}
        paymentsTemp={paymentsTemp}
        setPayments={setPayments}
        fiscalCode={true}
        goBack={true}
        onRefreshPayments={refreshPayments}
      />
  
  ) : (
<>
<div className="alert alert-warning" role="alert">
<strong>Attenzione! </strong>  Non ci sono pagamenti per l'utente selezionato.
      </div>

 </>     
      
      
      )}
 







 
  </>);
}


  
  
  
  
  


export default ListPayments;
